import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../shared/base.component';
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { PatientService } from '../patient.service';
import { FormBuilder } from '@angular/forms';
import { PatientsService } from '../../patients/patients.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-suicidality',
    templateUrl: 'suicidality.component.html',
    styleUrls: ['suicidality.component.scss'],
})

export class SuicidalityComponent extends BaseComponent implements OnInit {

    @Input() patientId: any;
    @Input() documents: any;
    @Input() questionnaireData: any;
    @ViewChild('tinymce', { static: false }) tinymce;

    @Output() navigateDocumentTab = new EventEmitter<any>();
    patientSub: Subscription;

    loadedData = true;
    suicidalities = [];
    callInfos = [];
    lang: string = this.translate.currentLang;
    therapyStep = 1;
    previousStep = 0;
    SuicidalityTypes = [
        {
            text: 'No suicidalities',
            value: 0
        },{
            text: 'Desire for tranquility',
            value: 1
        },{
            text: 'Feelings of being weary of life',
            value: 2
        },{
            text: 'Passive suicidal thoughts',
            value: 3
        },{
            text: 'Active suicidal thoughts',
            value: 4
        },{
            text: 'Concrete suicide attempt',
            value: 5
        },
    ];
    InfoTypes = [
        {
            text: 'Patient did not show',
            value: 0
        },{
            text: 'Patient did show',
            value: 1
        },{
            text: 'Patient had problems',
            value: 2
        }
    ];
    callInfo: string;
    ld = _;
    dataUpdated = false;
    selectedSuicidal: boolean = false;
    selectedTypeSuicidal: number = 0;
    selectedCredibly = "";
    selectedTypeInfo: number = 0;

    readonly SuicidalityColumns = [
        ['updated_at', 'Time, Date', 'col-xs-3 datetime', 'text'],
        ['suicidal', 'Suicidal', 'col-xs-2 suicidal-col', 'text'],
        ['type', 'Type of suicidality', 'col-xs-5 col-type', 'text'],
        ['credibly_distant', 'Credibly distant', 'col-xs-2 col-credibly', 'text'],
    ];
    readonly InfoCallColumns = [
        ['updated_at', 'Time, Date', 'col-xs-3 datetime', 'text'],
        ['type', 'Attendance', 'col-xs-4 col-type', 'text'],
        ['comment', 'Notes', 'col-xs-5 suicidal-col', 'text'],
    ];

    constructor(
        public appService: AppService,
        public authService: AuthService,
        public baseService: BaseService,
        public questionnairesService: QuestionnairesService,
        public patientService: PatientService,
        public fb: FormBuilder,
        public patientsService: PatientsService,
        public route: ActivatedRoute,
        public translate: TranslateService,
        public router: Router) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        this.translate.onLangChange.subscribe(value => {
            this.lang = value.lang;
        });
        /**
         * Get Call data
         */
        this.patientService.getCallInfo(this.patientId).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    this.callInfos = response['callings'];
                    this.suicidalities = response['documents'];
                }
            )
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        if (this.patientSub) {
            this.patientSub.unsubscribe();
        }
    }

    onChangeInsurances(data) {

    }

    getSuicidalName(value){
        let item = _.find(this.SuicidalityTypes, function(obj){
            return obj.value === value;
        });
        return item.text;
    }

    getInfoType(value){
        let item = _.find(this.InfoTypes, function(obj){
            return obj.value === value;
        });
        return item.text;
    }

    add(){
        const credibly = this.selectedCredibly ? 1 : 0;
        const data = {
            "type": this.selectedTypeSuicidal,
            "suicidal": this.selectedSuicidal ? 1 : 0,
            "credibly_distant": typeof this.selectedCredibly === "boolean"  ? credibly : null,
        };
        this.appService.isLoading = true;
        this.patientService.addSuicidal(this.patientId, data).pipe(
            finalize(() => this.appService.isLoading = false))
            .subscribe(
                response => {
                    if (response['success']) {
                        this.appService.isLoading = false;
                        return this.generateData(data, 1);
                    }
                }
            );
    }

    addInfoCall(){
        const data = {
            "type": this.selectedTypeInfo,
            "comment": this.selectedTypeInfo === this.InfoTypes[2].value ? this.callInfo : null,
            "questionnaire_id" : this.questionnaireData ? this.questionnaireData.id : 0
        };
        this.appService.isLoading = true;
        this.patientService.addCallInfo(this.patientId, data).pipe(
            finalize(() => this.appService.isLoading = false))
            .subscribe(
                response => {
                    if (response['success']) {
                        this.appService.isLoading = false;
                        return this.generateData(data);
                    }
                }
            );
    }

    generateData(data, type = 0){
        if(type === 1){
            return this.suicidalities.push(data);
        }
        return this.callInfos.push(data);
    }

    setTypeSuicidal(value){
        if(!value){
            this.selectedTypeSuicidal = this.SuicidalityTypes[0].value;
            this.selectedCredibly = "";
        }
    }
}
